/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Title/view.blocks to change it.
import * as fromData from 'Simple/Data'
import DataVaxiomPersonTitleSelect from 'DesignSystem/Data/DataVaxiom/DataVaxiomPerson/DataVaxiomPersonTitleSelect/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Title({
  children,
  viewPath = "/DesignSystem/DataVaxiomProfessionalView/Content/Details/Person/Title",
  onChange
  
}) {
let searchViewDetailsTitleValueData = fromData.useDataValue({ viewPath,
context: 'search',
path: 'view_details.title',
})
let searchViewDetailsTitleChangeData = fromData.useDataChange({ viewPath,
context: 'search',
path: 'view_details.title',
})
  return (<React.Fragment
>
<DataVaxiomPersonTitleSelect
  viewPath={`${viewPath}/DataVaxiomPersonTitleSelect`}
 disabled={true}
 size="medium"
 data="search.view_details.title"
 value={searchViewDetailsTitleValueData}
 onChange={searchViewDetailsTitleChangeData}
/>
{children}
</React.Fragment>)
}